<template>
  <div
    v-if="
      convertedEvents !== undefined &&
      convertedEvents?.length > 0 &&
      getFxMarketEconomicCalendar
    "
  >
    <v-row>
      <!-- Filtro de importância -->
      <v-col
        cols="6"
        md="12"
        lg="12"
        sm="12"
        class="d-flex flex-wrap align-center"
      >
        <span class="table-title text-no-wrap mr-3"> {{ $t('economicCalendar.filter3') }} </span>
        <base-filter
          :groups="filterGroups"
          :value="filterValue"
          :clear-label="$t('economicCalendar.clear')"
          @change="onFilterChange"
          @clear="resetFilters"
        />
      </v-col>
    </v-row>

    <v-row class="justify-start">
      <!-- EVENTS TODAY -->
      <v-col xs="12" sm="12" md="6" lg="6" class="px-5">
        <!--events today list-->
        <div>
          <div class="d-flex align-center pa-1">
            <span class="font-weight-bold">
              {{ $t("economicCalendar.today") }} ({{ formatDateMD(today) }})
            </span>
          </div>

          <div
            v-for="(groupedEvents, date) in eventsToday"
            :key="date + '-upcoming'"
          >
            <base-data-table
              :headers="headers"
              :items="calendarItems"
              :items-per-page="100"
              :expanded="expanded"
              item-key="id"
              hide-default-header
              hide-default-footer
              class="transparent table-content"
            >
              <!--header-->
              <template v-slot:header="{ props }">
                <thead>
                  <th
                    v-for="(index, headerIndex) in props.headers"
                    :key="headerIndex"
                    class="text-center"
                  >
                    <span>
                      {{
                        props.headers[headerIndex].text
                          ? props.headers[headerIndex].text.split(" ")[0]
                          : ""
                      }}
                    </span>
                  </th>
                </thead>
              </template>
              <!-- ROWS -->
              <template v-slot:item="{ item }">
                <tr :class="rowClass(item)">
                  <!-- Expand Icon if Comment exists (and screen is not XS) -->
                  <td v-if="!$vuetify.breakpoint.xs" class="icon-column">
                    <v-icon
                      v-if="item.comment"
                      @click="toggleExpand(item)"
                      class="expand-icon ma-2"
                    >
                      {{
                        expanded.includes(item)
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </td>

                  <!-- Time Column -->
                  <td class="time-column">
                    <span class="table-content text-no-wrap"
                      >{{ formatTime(item.date) }}
                    </span>
                  </td>

                  <!-- Country Column -->
                  <td class="country-column text-center">
                    <span>{{ item.country }}</span>
                  </td>

                  <!-- Importance Column -->
                  <td class="importance-column">
                    <v-icon :style="iconStyle(item)">{{
                      getSignalIcon(item.importance)
                    }}</v-icon>
                  </td>

                  <!-- Title Column -->
                  <td v-if="!$vuetify.breakpoint.xs">
                    <div class="d-flex">
                      <span
                        v-if="item.source_url"
                        @click="openEvent(item.source_url)"
                        style="cursor: pointer"
                        class="table-content text-truncate"
                      >
                        {{ item.title }}
                      </span>
                      <span class="table-content text-truncate" v-else>{{
                        item.title
                      }}</span>
                    </div>
                  </td>
                </tr>

                <!-- Title Row for XS screens -->
                <tr v-if="$vuetify.breakpoint.xs" :class="rowClass(item)">
                  <td
                    colspan="4"
                    class="d-flex align-center justify-space-between"
                  >
                    <span
                      v-if="item.source_url"
                      @click="openEvent(item.source_url)"
                      style="cursor: pointer"
                    >
                      {{ item.title }}
                    </span>
                    <span v-else>{{ item.title }}</span>

                    <v-icon
                      v-if="item.comment"
                      @click="toggleExpand(item)"
                      class="expand-icon ml-2"
                    >
                      {{
                        expanded.includes(item)
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </td>
                </tr>
              </template>

              <!-- Expanded Comment -->
              <template v-slot:expanded-item="{ item }">
                <tr>
                  <td :colspan="headers.length">
                    <v-card flat class="transparent">
                      <v-card-text>{{ item.comment }}</v-card-text>
                    </v-card>
                  </td>
                </tr>
              </template>
            </base-data-table>
          </div>

          <!-- If no events today -->
          <div v-if="Object.keys(eventsToday).length < 1 && eventsToday">
            <div class="d-flex pl-2 text-h6 font-weight-bold">
              <span class="text-h5 font-weight-bold pb-1">
                {{ $t("economicCalendar.today") }} ({{ formatDateMD(today) }})
              </span>
            </div>
            <div class="pl-2">
              {{
                isFilter
                  ? $t("economicCalendar.noEventsFiltered")
                  : $t("economicCalendar.noEvents") +
                    $t("economicCalendar.today") +
                    "."
              }}
            </div>
          </div>
        </div>
      </v-col>

      <!-- EVENTS NEXT DAY -->
      <v-col xs="12" sm="12" md="6" lg="6" class="px-5">
        <div>
          <div class="d-flex align-center pa-1" style="cursor: pointer">
            <span class="font-weight-bold">
              {{ getDayName(nextDay) }} ({{ formatDateMD(nextDay) }})</span
            >
          </div>

          <div v-for="(groupedEvents, date) in eventsNextDay" :key="date">
            <base-data-table
              :headers="headers"
              :items="groupedEvents"
              :items-per-page="100"
              :expanded="expanded"
              item-key="id"
              hide-default-header
              hide-default-footer
              class="transparent table-content"
            >
              <!--header-->
              <template v-slot:header="{ props }">
                <thead>
                  <th
                    v-for="(index, headerIndex) in props.headers"
                    :key="headerIndex"
                    class="text-center"
                  >
                    <span>
                      {{
                        props.headers[headerIndex].text
                          ? props.headers[headerIndex].text
                          : ""
                      }}
                    </span>
                  </th>
                </thead>
              </template>
              <!-- ROWS -->
              <template v-slot:item="{ item }">
                <tr>
                  <!-- Expand Icon if Comment exists (and screen is not XS)-->
                  <td v-if="!$vuetify.breakpoint.xs" class="icon-column">
                    <v-icon
                      v-if="item.comment"
                      @click="toggleExpand(item)"
                      class="expand-icon ma-2"
                    >
                      {{
                        expanded.includes(item)
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </td>

                  <!-- Time Column -->
                  <td class="time-column">
                    <span class="table-content text-no-wrap">{{
                      formatTime(item.date)
                    }}</span>
                  </td>

                  <!-- Country Column -->
                  <td class="country-column text-center">
                    <span>{{ item.country }}</span>
                  </td>

                  <!-- Importance Column -->
                  <td class="importance-column">
                    <v-icon>{{ getSignalIcon(item.importance) }}</v-icon>
                  </td>

                  <!-- Title Column -->
                  <td v-if="!$vuetify.breakpoint.xs">
                    <div class="d-flex">
                      <span
                        v-if="item.source_url"
                        @click="openEvent(item.source_url)"
                        style="cursor: pointer"
                        class="table-content text-truncate"
                      >
                        {{ item.title }}
                      </span>
                      <span class="table-content text-truncate" v-else>{{
                        item.title
                      }}</span>
                    </div>
                  </td>
                </tr>

                <!-- Title Row for XS screens -->
                <tr v-if="$vuetify.breakpoint.xs">
                  <td
                    colspan="4"
                    class="d-flex align-center justify-space-between"
                  >
                    <span
                      v-if="item.source_url"
                      @click="openEvent(item.source_url)"
                      style="cursor: pointer"
                    >
                      {{ item.title }}
                    </span>
                    <span v-else>{{ item.title }}</span>

                    <v-icon
                      v-if="item.comment"
                      @click="toggleExpand(item)"
                      class="expand-icon ml-2"
                    >
                      {{
                        expanded.includes(item)
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </td>
                </tr>
              </template>

              <!-- Expanded Comment -->
              <template v-slot:expanded-item="{ item }">
                <tr>
                  <td :colspan="headers.length">
                    <v-card flat class="transparent">
                      <v-card-text>{{ item.comment }}</v-card-text>
                    </v-card>
                  </td>
                </tr>
              </template>
            </base-data-table>
          </div>

          <!-- If no events for next day -->
          <div v-if="Object.keys(eventsNextDay).length < 1 && eventsNextDay">
            <div class="d-flex pl-4 text-h6 font-weight-bold">
              <span class="text-h5 font-weight-bold pb-1">
                {{ getDayName(nextDay) }} ({{ formatDateMD(nextDay) }})
              </span>
            </div>
            <div class="pl-4">
              {{
                isFilter
                  ? $t("economicCalendar.noEventsFiltered")
                  : $t("economicCalendar.noEvents") + getDayName(nextDay) + "."
              }}
            </div>
          </div>
        </div>
      </v-col>

      <!-- EVENTS OTHER DAYS -->
      <v-col xs="12" sm="12" md="12" lg="12">
        <div
          v-if="Object.keys(eventsOtherDays).length > 0"
          class="calendar-pills"
        >
          <div
            class="d-flex align-center pa-3"
            @click="toggleOtherDays('showOtherDays')"
            style="cursor: pointer"
          >
            <v-icon class="mr-2">
              {{ showOtherDays ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
            <span class="font-weight-bold">{{
              $t("economicCalendar.more")
            }}</span>
          </div>

          <div v-if="showOtherDays">
            <div v-for="(groupedEvents, date) in eventsOtherDays" :key="date">
              <div class="table-content d-flex table-title pl-4 py-1">
                <div>
                  <span>{{ formatFromCustomString(date, "date") }}</span>
                </div>
              </div>

              <base-data-table
                :headers="headers"
                :items="groupedEvents"
                :items-per-page="100"
                :expanded="expanded"
                item-key="id"
                hide-default-footer
                class="transparent"
              >
                <!-- ROWS -->
                <template v-slot:item="{ item }">
                  <tr>
                    <!-- Expand Icon if Comment exists (and screen is not XS)-->
                    <td v-if="!$vuetify.breakpoint.xs" class="icon-column">
                      <v-icon
                        v-if="item.comment"
                        @click="toggleExpand(item)"
                        class="expand-icon"
                      >
                        {{
                          expanded.includes(item)
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}
                      </v-icon>
                    </td>

                    <!-- Time Column -->
                    <td class="time-column">
                      <span class="table-content">{{
                        formatTime(item.date)
                      }}</span>
                    </td>

                    <!-- Country Column -->
                    <td class="country-column">
                      <span>{{ item.country }}</span>
                    </td>

                    <!-- Importance Column -->
                    <td class="importance-column">
                      <v-icon>{{ getSignalIcon(item.importance) }}</v-icon>
                    </td>

                    <!-- Title Column -->
                    <td v-if="!$vuetify.breakpoint.xs">
                      <span
                        v-if="item.source_url"
                        @click="openEvent(item.source_url)"
                        style="cursor: pointer"
                        class="table-content"
                      >
                        {{ item.title }}
                      </span>
                      <span class="table-content" v-else>{{ item.title }}</span>
                    </td>
                  </tr>

                  <!-- Title Row for XS screens -->
                  <tr v-if="$vuetify.breakpoint.xs">
                    <td
                      colspan="4"
                      class="d-flex align-center justify-space-between"
                    >
                      <span
                        v-if="item.source_url"
                        @click="openEvent(item.source_url)"
                        style="cursor: pointer"
                      >
                        {{ item.title }}
                      </span>
                      <span v-else>{{ item.title }}</span>

                      <v-icon
                        v-if="item.comment"
                        @click="toggleExpand(item)"
                        class="expand-icon ml-2"
                      >
                        {{
                          expanded.includes(item)
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}
                      </v-icon>
                    </td>
                  </tr>
                </template>

                <!-- Expanded Comment -->
                <template v-slot:expanded-item="{ item }">
                  <tr>
                    <td :colspan="headers.length">
                      <v-card flat class="transparent">
                        <v-card-text>{{ item.comment }}</v-card-text>
                      </v-card>
                    </td>
                  </tr>
                </template>
              </base-data-table>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <div class="loading-indicator">
      <v-progress-circular indeterminate color="primary" :size="50" :width="5">
      </v-progress-circular>
      <span class="ml-3 text-h4">{{ $t("extras.loadingDot") }} </span>
    </div>
  </div>
</template>

<script>
import { mapState, mapStores } from "pinia";
import {
  useFxMarketStore,
  useSettingsStore,
  useCalendarStore,
} from "@/store/index";
import { i18n } from "@/plugins/vuetify";
import * as utils from "@/utils/utils.js";

export default {
  props: {
    fontSize: { type: String, default: "" },
  },
  data() {
    return {
      expanded: [],
      showOtherDays: false,
      showToday: true,
      showTomorrow: false,
      showImportanceTooltip: false,
      tooltipPosition: { x: 0, y: 0 },
      selectedImportances: [],
      selectedCountries: [],
      isFilterOn: false,
      dialog: { open: false, day: null },
      nowMs: Date.now(),
      clockTimerId: null,
    };
  },
  mounted() {
    this.clockTimerId = setInterval(() => {
      this.nowMs = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    if (this.clockTimerId) clearInterval(this.clockTimerId);
  },
  computed: {
    ...mapStores(useCalendarStore),
    ...mapState(useFxMarketStore, ["getFxMarketEconomicCalendar"]),
    selectedCountriesFilter() {
      return this.calendarStore.calendarCountriesFilters;
    },
    selectedImportanceFilter() {
      return this.calendarStore.calendarImportanceFilters;
    },
    filterGroups() {
      return [
        {
          key: "importance",
          options: [-1, 0, 1].map((level) => ({
            value: level,
            label:
              level === -1
                ? this.$t("economicCalendar.importanceLow")
                : level === 0
                ? this.$t("economicCalendar.importanceMedium")
                : this.$t("economicCalendar.importanceHigh"),
            icon: this.getSignalIcon(level),
          })),
        },
        {
          key: "country",
          options: ["US", "EU", "BR"].map((country) => ({
            value: country,
            label: country,
          })),
        },
      ];
    },
    filterValue() {
      return {
        importance: this.selectedImportanceFilter,
        country: this.selectedCountriesFilter,
      };
    },
    isOnModal() {
      const settingsStore = useSettingsStore();
      return settingsStore.isModalOn;
    },
    headers() {
      return [
        {
          text: "",
          value: "expand",
          align: "start",
          sortable: false,
          width: "1vw",
        },
        {
          text: this.$t("economicCalendar.date"),
          value: "date",
          width: "3vw",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("economicCalendar.country"),
          value: "country",
          width: "2vw",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("economicCalendar.importance"),
          value: "importance",
          width: "2.5vw",
          align: "start",
        },
        {
          text: this.$t("economicCalendar.title"),
          value: "title",
          width: "10vw",
          align: "start",
        },
      ];
    },
    convertedEvents() {
      if (!this.getFxMarketEconomicCalendar) return [];
      return this.getFxMarketEconomicCalendar?.map((event) => ({
        actual: event.actual,
        actualRaw: event.actualRaw,
        category: event.category,
        comment: event.comment,
        country: event.country,
        currency: event.currency,
        date: new Date(event.date).getTime(),
        forecast: event.forecast,
        forecastRaw: event.forecastRaw,
        id: event.id,
        importance: event.importance,
        indicator: event.indicator,
        period: event.period,
        previous: event.previous,
        previousRaw: event.previousRaw,
        source: event.source,
        source_url: event.source_url,
        ticker: event.ticker,
        title: event.title,
      }));
    },
    filteredEvents() {
      return this.convertedEvents.filter((event) => {
        const matchImportance =
          this.selectedImportanceFilter.length === 0 ||
          this.selectedImportanceFilter.includes(event.importance);
        const matchCountry =
          this.selectedCountriesFilter.length === 0 ||
          this.selectedCountriesFilter.includes(event.country);
        return matchImportance && matchCountry;
      });
    },
    groupedFilteredEvents() {
      return this.filteredEvents.reduce((groups, event) => {
        const date = this.formatDate(event.date);
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(event);
        return groups;
      }, {});
    },
    today() {
      const { year, month, day } = utils.getDateParts(new Date());
      return new Date(`${year}-${month}-${day}T00:00:00`).getTime();
    },
    nextDay() {
      const { year, month, day } = utils.getDateParts(new Date());
      const baseDate = new Date(`${year}-${month}-${day}T00:00:00`);
      const nextDay = new Date(baseDate);
      nextDay.setDate(nextDay.getDate() + 1);

      const dayOfWeek = nextDay.getDay();
      if (dayOfWeek === 6) nextDay.setDate(nextDay.getDate() + 2);
      if (dayOfWeek === 0) nextDay.setDate(nextDay.getDate() + 1);

      return nextDay.getTime();
    },
    eventsToday() {
      return Object.keys(this.groupedFilteredEvents).reduce((acc, dateKey) => {
        const eventDate = new Date(this.formatDateMDY(dateKey));
        eventDate.setHours(0, 0, 0, 0);
        /**
        const eventDate = new Date(this.formatDateMDY(dateKey)).setHours(0, 0, 0, 0)
        if (eventDate === this.today) {
         */
        if (eventDate.getTime() <= this.today) {
          acc[dateKey] = this.groupedFilteredEvents[dateKey];
        }
        return acc;
      }, {});
    },
    eventsNextDay() {
      return Object.keys(this.groupedFilteredEvents).reduce((acc, dateKey) => {
        const eventDate = new Date(this.formatDateMDY(dateKey)).setHours(
          0,
          0,
          0,
          0,
        );
        if (eventDate === this.nextDay) {
          acc[dateKey] = this.groupedFilteredEvents[dateKey];
        }
        return acc;
      }, {});
    },
    eventsOtherDays() {
      const dayOfWeek = new Date().getDay();
      const excludeNextDay = dayOfWeek >= 0 && dayOfWeek <= 4;
      return Object.keys(this.groupedFilteredEvents).reduce((acc, dateKey) => {
        const eventDate = new Date(this.formatDateMDY(dateKey)).setHours(
          0,
          0,
          0,
          0,
        );
        if (
          eventDate !== this.today &&
          (!excludeNextDay || eventDate !== this.nextDay)
        ) {
          acc[dateKey] = this.groupedFilteredEvents[dateKey];
        }
        return acc;
      }, {});
    },
    isFilter() {
      return (
        this.selectedImportanceFilter.length > 0 ||
        this.selectedCountriesFilter.length > 0
      );
    },
    currentHourStartMs() {
      const d = new Date(this.nowMs);
      d.setHours(0, 0, 0);
      return d.getTime();
    },
    calendarItems() {
      const eventsArray = Object.values(this.eventsToday).flat();
      return this.isOnModal
        ? this.sortedByTimeAsc(eventsArray.filter(this.isUpcomingTodayByHour))
        : this.sortedByCollapseCalendar(
            eventsArray.filter(this.isUpcomingTodayByHour),
          );
    },
  },
  methods: {
    getSignalIcon(relevance) {
      switch (relevance) {
        case -1:
          return "mdi-signal-cellular-1";
        case 0:
          return "mdi-signal-cellular-2";
        case 1:
          return "mdi-signal-cellular-3";
        default:
          return "";
      }
    },
    formatTime(timestamp) {
      return utils.formatTime(timestamp);
    },
    formatDate(timestamp) {
      const dividedTimestamp = timestamp / 1000;
      return utils.formatDate(dividedTimestamp);
    },
    formatDateMD(timestamp) {
      const { day, month } = utils.getDateParts(timestamp);
      return utils.isDayFirstLocale(i18n.locale)
        ? `${day}/${month}`
        : `${month}/${day}`;
    },
    formatDateMDY(dateKey) {
      const [day, month, year] = dateKey.split("/");
      // Mantido como estava para pt/en; o espanhol entra junto com o portugues
      // por ser dia-primeiro tambem. (O nome das partes aqui parece invertido
      // em relacao ao que a funcao devolve - comportamento pre-existente, nao
      // mexido.)
      return utils.isDayFirstLocale(this.$i18n.locale)
        ? `${month}/${day}/${year}` // MM/DD/YYYY
        : dateKey;
    },
    formatFromCustomString(dateString, formatType) {
      return utils.formatFromCustomString(dateString, formatType);
    },
    getDayName(date) {
      const timeZone = utils.getTimeZone();

      const today = new Date();
      const eventDate = new Date(date);

      const formatter = new Intl.DateTimeFormat("en-CA", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const tomorrowStr = formatter.format(tomorrow);
      const todayStr = formatter.format(today);
      const eventStr = formatter.format(eventDate);

      if (eventStr === todayStr) {
        return this.$t("economicCalendar.today");
      }
      if (eventStr === tomorrowStr) {
        return this.$t("economicCalendar.tomorrow");
      }

      // UPDATED IN TheEconomicCalendar.vue > getDayName(): FIXED WEEKDAY ALWAYS RETURNING "MONDAY"
      // WHAT: the fallback used to unconditionally return "Monday"/"Segunda-feira"
      // regardless of eventDate's actual day of week.
      // WHERE: getDayName(), used to label calendar events further out than tomorrow.
      // WHY: any event 2+ days away was mislabeled "Monday" no matter what day
      // it actually fell on; deriving the real weekday index and looking it
      // up through $t() fixes both the mislabeling and the hardcoded text.
      const weekdayKeys = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      return this.$t(`economicCalendar.weekdays.${weekdayKeys[eventDate.getDay()]}`);
    },
    openEvent(url) {
      window.open(url, "_blank");
    },
    toggleExpand(item) {
      if (this.expanded.includes(item)) {
        this.expanded = this.expanded.filter((i) => i !== item);
      } else {
        this.expanded.push(item);
      }
    },
    toggleOtherDays(selectedDay) {
      if (this.hasOwnProperty(selectedDay)) {
        this[selectedDay] = !this[selectedDay];
      }
    },
    onFilterChange({ key, value }) {
      this.calendarStore.setCalendarFilterList(value, key);
      this.updateFilterFlag();
    },
    resetFilters() {
      this.selectedImportances = [];
      this.selectedCountries = [];
      this.calendarStore.resetCalendarFilter();
      this.isFilterOn = false;
    },
    updateFilterFlag() {
      this.isFilterOn =
        this.selectedImportanceFilter.length > 0 ||
        this.selectedCountriesFilter.length > 0;
    },
    isImminent(item) {
      const HALF_HOUR = 30 * 60 * 1000;
      const ONE_HOUR = 60 * 60 * 1000;
      const start = new Date(item.date).getTime();
      const highlightStart = start - HALF_HOUR;
      const highlightEnd = start + ONE_HOUR;
      return this.nowMs >= highlightStart && this.nowMs <= highlightEnd;
    },
    isPast(item) {
      const ONE_HOUR = 60 * 60 * 1000;
      const start = new Date(item.date).getTime() - ONE_HOUR;
      return this.nowMs > start;
    },
    isFuture(item) {
      return new Date(item.date).getTime() > this.nowMs;
    },
    rowClass(item) {
      if (this.isPast(item)) return { "event-past": true };
    },
    iconStyle(item) {
      const dark = this.$vuetify.theme.dark;
      if (this.isImminent(item)) return {};
      if (this.isPast(item))
        return {
          color: dark ? "rgba(255, 255, 255, 0.47)" : "rgba(0,0,0,0.87)",
        };
      // future
      return { color: dark ? "rgba(255,255,255,0.95)" : "rgba(0,0,0,0.54)" };
    },
    isPastTodayByHour(item) {
      return item.date < this.nowMs - 60 * 60 * 1000;
    },
    isUpcomingTodayByHour(item) {
      return item.date >= this.currentHourStartMs;
    },
    sortedByTimeAsc(items) {
      return items.slice().sort((a, b) => a.date - b.date);
    },
    sortedByTimeDesc(items) {
      return items.slice().sort((a, b) => b.date - a.date);
    },
    sortedByCollapseCalendar(items) {
      const pastItems = items
        .filter((i) => i.date < this.nowMs + 60 * 60 * 1000)
        .sort((a, b) => a.date - b.date)
        .slice(-4);
      items = items
        .filter((i) => !this.isPast(i))
        .sort((a, b) => a.date - b.date);
      if (items.length >= 3) {
        return items;
      }
      return [...pastItems, ...items];
    },
  },
};
</script>

<style scoped>
.table-content {
  font-size: clamp(0.5rem, 1vw, 0.7rem) !important;
  line-height: clamp(0.7rem, 1.5vw, 0.8rem) !important;
}

td {
  padding: 0rem 1rem !important;
}

::v-deep .v-data-table th {
  font-size: 0.7rem !important;
  white-space: nowrap !important;
  padding: 0.2rem 1rem 0.5rem 0rem;
}
::v-deep .v-data-table thead th:first-of-type {
  width: 3.5vw;
}
::v-deep .v-data-table thead th:nth-of-type(2),
th:nth-of-type(3),
th:nth-of-type(4) {
  width: clamp(4vw, 4.5vw, 6vw) !important;
}

.three-dot-icon {
  opacity: 0.5;
  position: absolute;
  left: 50%;
  bottom: -20px;
}
.table-title {
  background-color: #151515;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  width: 100%;
  table-layout: fixed;
}

td:last-child,
th:last-child {
  width: auto;
  white-space: normal;
}

/* Imminent: whole row lightly highlighted */
.event-imminent {
  background-color: rgba(0, 104, 178, 0.081);
  font-weight: bold;
}

.theme--light .event-past td,
.theme--light .event-past span {
  color: rgba(0, 0, 0, 0.478);
}

.theme--light .event-future td,
.theme--light .event-future span {
  color: rgba(0, 0, 0, 0.54);
}

.theme--dark .event-past td,
.theme--dark .event-past span {
  color: rgba(255, 255, 255, 0.312);
}

.theme--dark .event-future td,
.theme--dark .event-future span {
  color: rgba(255, 255, 255, 0.95);
}

/* keep expanded comment readable on highlighted rows */
.event-imminent .v-card,
.event-imminent .v-card__text {
  background-color: transparent;
}

/* ::v-deep(.v-data-table__wrapper) {
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
} */

@media (max-width: 599px) {
  .theme--dark.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > td:not(.v-data-table__mobile-row) {
    border-bottom: none;
  }

  .theme--dark.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(2n) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
}

@media (max-width: 1400px) and (min-width: 950px) {
  .filters {
    flex-wrap: wrap !important;
  }
}

.icon-column {
  width: 10px;
}

.time-column {
  width: 100px;
}

.country-column {
  width: 100px;
}

.calendar-pills {
  border: 1px solid #ccc;
  border-radius: 8px;
}

.loading-indicator {
  /**d-flex justify-center align-center  flex-gow-1  */
  margin: 10rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}
</style>
